var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,class:['box', item.isSpecial ? 'item1' : 'item'],on:{"click":function($event){return _vm.handleBoxClick(item.content)}}},[_vm._v(" "+_vm._s(item.content)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }